import 'react-perfect-scrollbar/dist/css/styles.css';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@material-ui/core';
import { ThemeProvider } from "styled-components"
import GlobalStyles from './components/GlobalStyles';
import theme from './theme';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';

import { ScansProvider } from "./contexts/ScansContext";
import { PopupNotifProvider } from "./contexts/PopupNotifContext";

import DashboardLayout from './components/DashboardLayout';
import MainLayout from './components/MainLayout';

import Account from './pages/Account';
import Scans from './pages/Scans'
import ViewScan from './pages/ViewScan'
import ViewScanUsers from './pages/ViewScanUsers'
import CreateScan from './pages/CreateScan'

import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import ValidateCode from './pages/ValidateCode';
import RegisterCandidat from './pages/RegisterCandidat'
import Home from './pages/Home';
import NotFound from './pages/NotFound';


import { isLoggedIn } from "./utils/auth"

function RequireAuthAdmin({ children }: { children: JSX.Element }) {
  let location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  return (
    <DashboardLayout>
      <ScansProvider>
        {children}
      </ScansProvider>
    </DashboardLayout>
  );
}

function GoToHome({ children }: { children: JSX.Element }) {
  let location = useLocation();
  if (isLoggedIn()) {
    return <Navigate to="/app/scans" state={{ from: location }} />;
  } else {
    return <Navigate to="/home" state={{ from: location }} />;
  }
}

function GoTo404({ children }: { children: JSX.Element }) {
  let location = useLocation();
  return <Navigate to="/404" state={{ from: location }} />;
}

function AlwaysLoginRedirect({ children }: { children: JSX.Element }) {
  let location = useLocation();
  if (isLoggedIn()) {
    return <Navigate to="/" state={{ from: location }} />;
  }

  return children;
}

const App = () => {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <PopupNotifProvider>
            <GlobalStyles />
            <Routes>
              <Route exact path='/home' element={
                <AlwaysLoginRedirect>
                  <MainLayout>
                    <Home/>
                  </MainLayout>
                </AlwaysLoginRedirect>
              }/>
              <Route exact path='/login' element={
                <AlwaysLoginRedirect>
                  <MainLayout>
                    <Login/>
                  </MainLayout>
                </AlwaysLoginRedirect>
              }/>
              <Route exact path='/sign-up' element={
                <AlwaysLoginRedirect>
                  <MainLayout>
                    <SignUp/>
                  </MainLayout>
                </AlwaysLoginRedirect>
              }/>
              <Route exact path='/forgotPassword' element={
                <AlwaysLoginRedirect>
                  <MainLayout>
                    <ForgotPassword/>
                  </MainLayout>
                </AlwaysLoginRedirect>
              }/>
              <Route exact path='/resetPassword' element={
                <AlwaysLoginRedirect>
                  <MainLayout>
                    <ResetPassword/>
                  </MainLayout>
                </AlwaysLoginRedirect>
              }/>
              <Route exact path='/validateCode' element={
                <AlwaysLoginRedirect>
                  <MainLayout>
                    <ValidateCode/>
                  </MainLayout>
                </AlwaysLoginRedirect>
              }/>
              <Route exact path='/registerCandidat' element={
                <AlwaysLoginRedirect>
                  <MainLayout>
                    <RegisterCandidat/>
                  </MainLayout>
                </AlwaysLoginRedirect>
              }/>
              <Route exact path='/404' element={
                <MainLayout>
                  <NotFound/>
                </MainLayout>
              }/>


              <Route exact path="/" element={
                <GoToHome/>
              }/>
              <Route exact path="/app/scan" element={
                <GoToHome/>
              }/>
              <Route exact path="/app/scan/:id" element={
                <RequireAuthAdmin>
                  <ViewScan />
                </RequireAuthAdmin>
              }/>
              <Route exact path="/app/scan/:id/invitees" element={
                <RequireAuthAdmin>
                  <ViewScanUsers />
                </RequireAuthAdmin>
              }/>
              <Route exact path="/app/scan/:id/completed" element={
                <RequireAuthAdmin>
                  <ViewScanUsers />
                </RequireAuthAdmin>
              }/>
              <Route exact path="/app/scan/:id/passed" element={
                <RequireAuthAdmin>
                  <ViewScanUsers />
                </RequireAuthAdmin>
              }/>
              <Route exact path="/app/scans" element={
                <RequireAuthAdmin>
                  <Scans />
                </RequireAuthAdmin>
              }/>
              <Route exact path="/app/createScan" element={
                <RequireAuthAdmin>
                  <CreateScan />
                </RequireAuthAdmin>
              }/>
              <Route exact path="/app/account" element={
                <RequireAuthAdmin>
                  <Account />
                </RequireAuthAdmin>
              }/>

              <Route exact path='*' element={
                <GoTo404/>
              }/>
            </Routes>
          </PopupNotifProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
